import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { services } from '../../data/mock';
import { ArrowRight } from 'lucide-react';

const ServicesSection = () => {
  return (
    <section className="section-padding bg-[#0B0B0B]">
      <div className="container-luxury">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-luxury mb-6">
            Нашите <span className="gradient-text">услуги</span>
          </h2>
          <p className="text-lg text-[#A9A9A9] leading-relaxed">
            Цялостен процес от консултация до финализиране на сделката с пълна правна и финансова сигурност
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const IconComponent = Icons[service.icon];
            
            return (
              <div 
                key={service.id}
                className="card-luxury group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/20 group-hover:scale-110 transition-all duration-300">
                  {IconComponent && (
                    <IconComponent className="w-8 h-8 text-[#D4AF37]" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-2xl font-serif font-semibold text-[#F6F2E8] mb-4">
                  {service.title}
                </h3>
                
                <p className="text-[#A9A9A9] leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* CTA Link */}
                <Link 
                  to="/services"
                  className="inline-flex items-center text-[#D4AF37] font-medium hover:text-[#F3D98B] transition-colors duration-300 group/link"
                >
                  Научете повече
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                </Link>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <Link to="/services" className="btn-primary">
            Разгледайте всички услуги
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
